// Hooks
import { useEffect, useState } from "react";
// Navbar Components
import {
  NavbarContainer,
  LeftContainer,
  RightContainer,
  NavbarInnerContainer,
  NavbarExtendedContainer,
  NavbarLinkContainer,
  NavbarLink,
  OpenLinksButton,
  NavbarLinkExtended,
} from "./Navbar.style";

// icon
import { BsX, BsList } from "react-icons/bs";

const Navbar = () => {
  // Navbar Hamburguer Hook
  const [extendNavbar, setExtendNavbar] = useState(false);

  // navbar position prop
  const [position, setPosition] = useState("absolute");

  const changePosition = () => {
    if (window.pageYOffset >= 1) {
      setPosition("fixed");
    } else {
      setPosition("absolute");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changePosition);

    return () => {
      window.removeEventListener("scroll", changePosition);
    };
  }, []);

  return (
    <NavbarContainer extendNavbar={extendNavbar} positionNavbar={position}>
      <NavbarInnerContainer>
        <LeftContainer>
          <NavbarLinkContainer>
            <NavbarLink
              to="home"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              Home
            </NavbarLink>

            <NavbarLink
              to="about"
              spy={true}
              smooth={true}
              offset={-90}
              duration={500}
            >
              About
            </NavbarLink>

            <NavbarLink
              to="skills"
              spy={true}
              smooth={true}
              offset={-90}
              duration={500}
            >
              Skills
            </NavbarLink>

            <NavbarLink
              to="projects"
              spy={true}
              smooth={true}
              offset={-90}
              duration={500}
            >
              Projects
            </NavbarLink>

            <NavbarLink
              to="contact"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
            >
              Contact
            </NavbarLink>

            <OpenLinksButton
              onClick={() => setExtendNavbar((currentValue) => !currentValue)}
            >
              {extendNavbar ? <BsX /> : <BsList />}
            </OpenLinksButton>
          </NavbarLinkContainer>
        </LeftContainer>
        <RightContainer></RightContainer>
      </NavbarInnerContainer>
      {extendNavbar && (
        <NavbarExtendedContainer>
          <NavbarLinkExtended
            to="home"
            spy={true}
            smooth={true}
            offset={0}
            duration={500}
            onClick={() => setExtendNavbar(false)}
          >
            Home
          </NavbarLinkExtended>
          <NavbarLinkExtended
            to="about"
            spy={true}
            smooth={true}
            offset={-90}
            duration={500}
            onClick={() => setExtendNavbar(false)}
          >
            About
          </NavbarLinkExtended>
          <NavbarLinkExtended
            to="skills"
            spy={true}
            smooth={true}
            offset={-90}
            duration={500}
            onClick={() => setExtendNavbar(false)}
          >
            Skills
          </NavbarLinkExtended>
          <NavbarLinkExtended
            to="projects"
            spy={true}
            smooth={true}
            offset={-90}
            duration={500}
            onClick={() => setExtendNavbar(false)}
          >
            Projects
          </NavbarLinkExtended>
          <NavbarLinkExtended
            to="contact"
            spy={true}
            smooth={true}
            offset={-90}
            duration={500}
            onClick={() => setExtendNavbar(false)}
          >
            Contact
          </NavbarLinkExtended>
        </NavbarExtendedContainer>
      )}
    </NavbarContainer>
  );
};

export default Navbar;
